import { render, staticRenderFns } from "./welcome.vue?vue&type=template&id=e266a74e&scoped=true&lang=pug"
import script from "./welcome.vue?vue&type=script&lang=js"
export * from "./welcome.vue?vue&type=script&lang=js"
import style0 from "../access.scss?vue&type=style&index=0&id=e266a74e&prod&lang=scss&scoped=true&external"
import style1 from "./welcome.vue?vue&type=style&index=1&id=e266a74e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e266a74e",
  null
  
)

export default component.exports